const LOCAL_DEV_HOSTS = new Set(["localhost", "127.0.0.1", "::1"]);

export function isLocalDevHost(hostname = typeof window !== "undefined" ? window.location.hostname : ""): boolean {
  return import.meta.env.DEV && LOCAL_DEV_HOSTS.has(hostname);
}

export function isLocalAdminPathname(pathname: string, search = ""): boolean {
  return (
    pathname === "/admin"
    || pathname.startsWith("/admin/")
    || pathname === "/aramlas/admin"
    || pathname.startsWith("/aramlas/admin/")
    || search.includes("surface=admin")
  );
}

export function shouldBootstrapAdminApp(pathname: string, search = ""): boolean {
  if (import.meta.env.PROD && import.meta.env.VITE_APP_SURFACE === "admin") {
    return true;
  }

  return isLocalDevHost() && isLocalAdminPathname(pathname, search);
}
